console.log('taxonomy-vehicule.js loaded');
